import { loginService } from "@/api/services/loginService";
import { UserVo } from "@supplier/entity";
import { useUserStore } from "@/stores/modules/user";
import { useTabsStore } from "@/stores/modules/tabs";
import { institutionApplyService } from "@/api/services/institutionApplyService.ts";
import { INSTITUTION_STATE } from "@supplier/meta";

/** 登录来源 */
enum LOGIN_SOURCE {
    /** 浏览器 */
    WEB = "web"
}

export const login = async (code: string) => {
    const userStore = useUserStore();
    const tabStore = useTabsStore();
    console.log(userStore, "-----");
    const data = await loginService.enterpriseWeChatLogin({ code, source: LOGIN_SOURCE.WEB, url: "/" });
    userStore.setToken(data.accessToken);
    tabStore.closeAllTab();
};

export const getUserInfo = async () => {
    try {
        const userStore = useUserStore();
        const data: UserVo = await loginService.getUserInfo();
        userStore.setUserInfo(data);
        userStore.setMobile(data.user.mobile);
        // 企业认证状态
        userStore.setEnterpriseAuth(data.supplier.applyState);
    } catch (e) {
        console.log(e);
    }
};
